import React, { useState, useEffect } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Button,
  Modal,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Chip,
  IconButton,
  Tooltip,
  TablePagination,
  CircularProgress,
} from "@mui/material";
import {
  Edit as EditIcon,
  Visibility as ViewIcon,
  Person as PersonIcon,
  Close as CloseIcon,
} from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import { get, post } from "../../../utility/fetchFinance";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontWeight: 600,
  backgroundColor: "#f5f5f5",
  color: "#333",
}));

const StyledModal = styled(Modal)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

const ModalContent = styled(Box)(({ theme }) => ({
  backgroundColor: "white",
  borderRadius: "12px",
  padding: "24px",
  minWidth: "500px",
  maxWidth: "600px",
  maxHeight: "80vh",
  overflow: "auto",
  boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
}));

const ActionButton = styled(Button)(({ theme }) => ({
  borderRadius: "8px",
  textTransform: "none",
  padding: "8px 16px",
  fontWeight: 600,
  margin: "0 4px",
}));

const PatientsList = () => {
  const [patients, setPatients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // Modal form data
  const [modalData, setModalData] = useState({
    selectedCategory: "",
    assignedNurse: "",
  });

  // Dropdown options
  const [categories, setCategories] = useState([]);
  const [nurses, setNurses] = useState([]);
  const [loadingDropdowns, setLoadingDropdowns] = useState(false);

  // Mock patient data based on your schema
  const mockPatients = [
    {
      patientId: 1298,
      firstName: "OSASUYI",
      lastName: "MERCY",
      gender: "",
      dateOfBirth: "1985-03-08T00:00:00+00:00",
      email: "linda.edosa@primedewsmedicalcentre.com.ng",
      phoneNumber: "08134848997",
      stateOfOrigin: "Edo",
      lga: "ORDE",
      placeOfBirth: "BENIN",
      maritalStatus: "Married",
      nationality: "Nigerian",
      nurseId: 215,
      doctorId: 0,
      pictureUrl: null,
      patientHMOId: 0,
      hmoPackageId: 0,
      patientRef: "HS010879",
      hmoId: 0,
      createdAt: "2025-05-03T11:44:44.2408103+00:00",
      updatedAt: "2025-05-03T13:05:41.6655052+00:00",
      modifiedByName: null,
      nin: "",
      modifiedBy: 0,
      isReferred: false,
    },
    {
      patientId: 1314,
      firstName: "ESTHER",
      lastName: "AGHO",
      gender: "Female",
      dateOfBirth: "1963-12-07T00:00:00+00:00",
      email: "",
      phoneNumber: "08158352083",
      stateOfOrigin: "Edo",
      lga: "oredo",
      placeOfBirth: "benin",
      maritalStatus: "Married",
      nationality: "Nigerian",
      nurseId: 215,
      doctorId: 0,
      pictureUrl: null,
      patientHMOId: 0,
      hmoPackageId: 0,
      patientRef: "HS023870",
      hmoId: 0,
      createdAt: "2025-05-07T14:15:25.1143262+00:00",
      updatedAt: "2025-05-07T14:26:23.2809555+00:00",
      modifiedByName: null,
      nin: "",
      modifiedBy: 0,
      isReferred: false,
    },
    {
      patientId: 1316,
      firstName: "BEAUTY",
      lastName: "EDOKPOLOR",
      gender: "Female",
      dateOfBirth: "2003-05-21T00:00:00+00:00",
      email: "",
      phoneNumber: "08145904413",
      stateOfOrigin: "Edo",
      lga: "",
      placeOfBirth: "",
      maritalStatus: "Married",
      nationality: "Nigerian",
      nurseId: 215,
      doctorId: 0,
      pictureUrl: null,
      patientHMOId: 0,
      hmoPackageId: 0,
      patientRef: "HS051268",
      hmoId: 0,
      createdAt: "2025-05-08T08:43:53.1891441+00:00",
      updatedAt: "2025-05-08T09:14:24.3194205+00:00",
      modifiedByName: null,
      nin: "",
      modifiedBy: 0,
      isReferred: false,
    },
    {
      patientId: 1321,
      firstName: "DANJUMA",
      lastName: "EL-UMAR",
      gender: "Male",
      dateOfBirth: "1971-06-13T00:00:00+00:00",
      email: "danelumar@yahoo.com",
      phoneNumber: "08033039215",
      stateOfOrigin: "Edo",
      lga: "Oredo",
      placeOfBirth: "AMAGBA",
      maritalStatus: "Married",
      nationality: "Nigerian",
      nurseId: 0,
      doctorId: 0,
      pictureUrl: null,
      patientHMOId: 0,
      hmoPackageId: 0,
      patientRef: "",
      hmoId: 0,
      createdAt: "2025-05-07T00:00:00+00:00",
      updatedAt: "2025-08-09T12:24:02.7969116+00:00",
      modifiedByName: "Unekwuojo Maji",
      nin: "",
      modifiedBy: 241,
      isReferred: false,
    },
    {
      patientId: 1527,
      firstName: "ABARIOWEI",
      lastName: "SWEETLIFE",
      gender: "Male",
      dateOfBirth: "1993-08-06T00:00:00+00:00",
      email: "email@example.com",
      phoneNumber: "8056340578",
      stateOfOrigin: "Edo",
      lga: "Oredo",
      placeOfBirth: "AMAGBA",
      maritalStatus: "Married",
      nationality: "Nigerian",
      nurseId: 0,
      doctorId: 0,
      pictureUrl: null,
      patientHMOId: 0,
      hmoPackageId: 0,
      patientRef: "HS003657",
      hmoId: 0,
      createdAt: "2025-05-07T00:00:00+00:00",
      updatedAt: "2025-05-07T00:00:00+00:00",
      modifiedByName: null,
      nin: null,
      modifiedBy: 35,
      isReferred: true,
    },
  ];

  useEffect(() => {
    // Simulate loading patients - replace with actual API call
    const loadPatients = () => {
      setLoading(true);
      setTimeout(() => {
        setPatients(mockPatients);
        setLoading(false);
      }, 1000);
    };

    loadPatients();
  }, []);

  // Fetch categories and nurses for dropdowns
  const fetchDropdownData = async () => {
    setLoadingDropdowns(true);
    try {
      // Fetch categories from API
      const categoryResponse = await get({ endpoint: "/category/list/1/1000", auth: true });
      if (
        categoryResponse &&
        categoryResponse.data &&
        categoryResponse.data.categories
      ) {
        setCategories(categoryResponse.data.categories);
      } else {
        // Fallback categories if API fails
        setCategories([
          {
            categoryId: 1,
            categoryName: "General Medicine",
            description: "General medical consultation",
          },
          {
            categoryId: 2,
            categoryName: "Pediatrics",
            description: "Children's health care",
          },
          {
            categoryId: 3,
            categoryName: "Cardiology",
            description: "Heart and cardiovascular system",
          },
          {
            categoryId: 4,
            categoryName: "Orthopedics",
            description: "Bone and joint care",
          },
        ]);
      }

      // Mock nurse data - replace with actual API call
      setNurses([
        {
          nurseId: 1,
          firstName: "Nurse Jane",
          lastName: "Wilson",
          department: "ICU",
        },
        {
          nurseId: 2,
          firstName: "Nurse Mark",
          lastName: "Taylor",
          department: "Emergency",
        },
        {
          nurseId: 3,
          firstName: "Nurse Emily",
          lastName: "Anderson",
          department: "General Ward",
        },
        {
          nurseId: 4,
          firstName: "Nurse David",
          lastName: "Thomas",
          department: "Surgery",
        },
      ]);
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
      // Set fallback data on error
      setCategories([
        {
          categoryId: 1,
          categoryName: "General Medicine",
          description: "General medical consultation",
        },
        {
          categoryId: 2,
          categoryName: "Pediatrics",
          description: "Children's health care",
        },
        {
          categoryId: 3,
          categoryName: "Cardiology",
          description: "Heart and cardiovascular system",
        },
        {
          categoryId: 4,
          categoryName: "Orthopedics",
          description: "Bone and joint care",
        },
      ]);
    } finally {
      setLoadingDropdowns(false);
    }
  };

  const handleActionClick = (patient) => {
    setSelectedPatient(patient);
    setModalData({
      selectedCategory: "",
      assignedNurse: patient.nurseId || "",
    });
    setModalOpen(true);
    fetchDropdownData();
  };

  const handleModalClose = () => {
    setModalOpen(false);
    setSelectedPatient(null);
    setModalData({ selectedCategory: "", assignedNurse: "" });
  };

  const handleModalSubmit = async () => {
    try {
      // Here you would make an API call to update patient assignments
      console.log("Updating patient assignments:", {
        patientId: selectedPatient.patientId,
        categoryId: modalData.selectedCategory,
        nurseId: modalData.assignedNurse,
      });

      // Mock API call - replace with actual endpoint
      // const response = await post(`patients/${selectedPatient.patientId}/assign`, {
      //   categoryId: modalData.selectedCategory,
      //   nurseId: modalData.assignedNurse
      // });

      alert("Patient assignments updated successfully!");
      handleModalClose();
    } catch (error) {
      console.error("Error updating patient assignments:", error);
      alert("Failed to update patient assignments. Please try again.");
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const paginatedPatients = patients.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="400px"
      >
        <CircularProgress size={50} />
      </Box>
    );
  }

  return (
    <Box sx={{ maxWidth: 1400, margin: "0 auto", padding: 2 }}>
      <Typography
        variant="h4"
        gutterBottom
        sx={{ color: "#2E7D32", fontWeight: 600 }}
      >
        Patient List
      </Typography>

      <Paper sx={{ borderRadius: "12px", overflow: "hidden" }}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <StyledTableCell>Patient Ref</StyledTableCell>
                <StyledTableCell>Name</StyledTableCell>
                <StyledTableCell>Gender</StyledTableCell>
                <StyledTableCell>Date of Birth</StyledTableCell>
                <StyledTableCell>Phone</StyledTableCell>
                <StyledTableCell>Email</StyledTableCell>
                <StyledTableCell>State</StyledTableCell>
                <StyledTableCell>Status</StyledTableCell>
                <StyledTableCell>Actions</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedPatients.map((patient) => (
                <TableRow key={patient.patientId} hover>
                  <TableCell>{patient.patientRef || "N/A"}</TableCell>
                  <TableCell>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <PersonIcon sx={{ marginRight: 1, color: "#666" }} />
                      <Box>
                        <Typography variant="body2" fontWeight={600}>
                          {patient.firstName} {patient.lastName}
                        </Typography>
                        <Typography variant="caption" color="textSecondary">
                          ID: {patient.patientId}
                        </Typography>
                      </Box>
                    </Box>
                  </TableCell>
                  <TableCell>{patient.gender || "N/A"}</TableCell>
                  <TableCell>{formatDate(patient.dateOfBirth)}</TableCell>
                  <TableCell>{patient.phoneNumber}</TableCell>
                  <TableCell>
                    <Typography
                      variant="body2"
                      sx={{
                        maxWidth: 200,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {patient.email || "N/A"}
                    </Typography>
                  </TableCell>
                  <TableCell>{patient.stateOfOrigin}</TableCell>
                  <TableCell>
                    <Box sx={{ display: "flex", gap: 1 }}>
                      {patient.isReferred && (
                        <Chip label="Referred" color="info" size="small" />
                      )}
                      {patient.hmoId > 0 && (
                        <Chip label="HMO" color="success" size="small" />
                      )}
                      {patient.doctorId > 0 ? (
                        <Chip label="Assigned" color="primary" size="small" />
                      ) : (
                        <Chip label="Unassigned" color="warning" size="small" />
                      )}
                    </Box>
                  </TableCell>
                  <TableCell>
                    <ActionButton
                      variant="contained"
                      size="small"
                      onClick={() => handleActionClick(patient)}
                      sx={{
                        backgroundColor: "#1976D2",
                        "&:hover": { backgroundColor: "#1565C0" },
                      }}
                      startIcon={<EditIcon />}
                    >
                      Assign
                    </ActionButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50]}
          component="div"
          count={patients.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>

      {/* Assignment Modal */}
      <StyledModal open={modalOpen} onClose={handleModalClose}>
        <ModalContent>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 3,
            }}
          >
            <Typography variant="h6" sx={{ color: "#2E7D32", fontWeight: 600 }}>
              Assign Patient: {selectedPatient?.firstName}{" "}
              {selectedPatient?.lastName}
            </Typography>
            <IconButton onClick={handleModalClose}>
              <CloseIcon />
            </IconButton>
          </Box>

          {selectedPatient && (
            <Box
              sx={{
                marginBottom: 3,
                padding: 2,
                backgroundColor: "#f5f5f5",
                borderRadius: 2,
              }}
            >
              <Typography variant="body2" color="textSecondary">
                <strong>Patient ID:</strong> {selectedPatient.patientId}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                <strong>Reference:</strong>{" "}
                {selectedPatient.patientRef || "N/A"}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                <strong>Phone:</strong> {selectedPatient.phoneNumber}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                <strong>State:</strong> {selectedPatient.stateOfOrigin}
              </Typography>
            </Box>
          )}

          {loadingDropdowns ? (
            <Box display="flex" justifyContent="center" padding={4}>
              <CircularProgress />
            </Box>
          ) : (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
              {/* Category Dropdown */}
              <FormControl fullWidth>
                <InputLabel>Select Category</InputLabel>
                <Select
                  value={modalData.selectedCategory}
                  onChange={(e) =>
                    setModalData({
                      ...modalData,
                      selectedCategory: e.target.value,
                    })
                  }
                  label="Select Category"
                >
                  <MenuItem value="">
                    <em>No Category Selected</em>
                  </MenuItem>
                  {categories.map((category) => (
                    <MenuItem
                      key={category.categoryId}
                      value={category.categoryId}
                    >
                      {category.categoryName} - {category.description}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {/* Nurse Dropdown */}
              <FormControl fullWidth>
                <InputLabel>Assign Nurse</InputLabel>
                <Select
                  value={modalData.assignedNurse}
                  onChange={(e) =>
                    setModalData({
                      ...modalData,
                      assignedNurse: e.target.value,
                    })
                  }
                  label="Assign Nurse"
                >
                  <MenuItem value="">
                    <em>No Nurse Assigned</em>
                  </MenuItem>
                  {nurses.map((nurse) => (
                    <MenuItem key={nurse.nurseId} value={nurse.nurseId}>
                      {nurse.firstName} {nurse.lastName} - {nurse.department}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {/* Action Buttons */}
              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  justifyContent: "flex-end",
                  marginTop: 2,
                }}
              >
                <Button
                  variant="outlined"
                  onClick={handleModalClose}
                  sx={{ color: "#666", borderColor: "#666" }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  onClick={handleModalSubmit}
                  sx={{
                    backgroundColor: "#2E7D32",
                    "&:hover": { backgroundColor: "#1B5E20" },
                  }}
                >
                  Update Assignments
                </Button>
              </Box>
            </Box>
          )}
        </ModalContent>
      </StyledModal>
    </Box>
  );
};

export default PatientsList;
